import EditIcon from "@redotech/redo-icons/edit-02.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export const OrderNoteFilter: AdvancedTableFilter = {
  type: AdvancedFilterType.ARRAY_TO_STRING,
  operators: [
    ArrayStringFilterOperator.IS_EMPTY,
    ArrayStringFilterOperator.IS_NOT_EMPTY,
    ArrayStringFilterOperator.CONTAINS,
    ArrayStringFilterOperator.NOT_CONTAINS,
  ],
  data: {
    name: "orderNote",
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.IS_NOT_EMPTY,
  },
  itemLabel: "note",
  Icon: EditIcon,
  values: [],
  displayName: "Order note",
};
